module.exports = "data:text/markdown;base64,IyMjIFN0YXRpb25zIExpdmU6ClRvdGFsIG51bWJlciBvZiBzdGF0aW9ucyBsb2dnZWQgaW4gZm9yIHRoZSBjdXJyZW50IGNhbXBhaWduLgo="